/**
 * Transform camelCase keys to snake_case with underscores before units
 * Examples:
 * - minuteSensorAcquirePeriod -> minute_sensorAcquirePeriod
 * - celsiusMin -> celsius_Min
 * - percentMax -> percent_Max
 * - posPeriod -> pos_period
 */
export const formatConfigKeys = (obj: any): any => {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(formatConfigKeys);
  }

  const result: any = {};

  Object.keys(obj).forEach((key) => {
    let formattedKey = key;

    // Handle unit prefixes: minute, celsius, percent, hpa, numberOfEvents, pos
    const unitPrefixes = [
      { pattern: /^minute([A-Z])/, replacement: 'minute_$1' },
      { pattern: /^celsius([A-Z])/, replacement: 'celsius_$1' },
      { pattern: /^percent([A-Z])/, replacement: 'percent_$1' },
      { pattern: /^hpa([A-Z])/, replacement: 'hpa_$1' },
      { pattern: /^numberOfEvents([A-Z])/, replacement: 'numberOfEvents_$1' },
      { pattern: /^pos([A-Z])/, replacement: 'pos_$1' },
    ];

    unitPrefixes.forEach(({ pattern, replacement }) => {
      if (pattern.test(key)) {
        formattedKey = key.replace(pattern, replacement);
      }
    });

    result[formattedKey] = formatConfigKeys(obj[key]);
  });

  return result;
};
